(function () {
  var reduceMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var slickCarouselDefaults = {
    infinite: true,
    autoplay: !reduceMotion,
    autoplaySpeed: 4500,
    speed: 650,
    pauseOnHover: true,
    pauseOnFocus: true,
    cssEase: 'ease-in-out',
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: !reduceMotion,
          autoplaySpeed: 4500,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          autoplay: !reduceMotion,
          autoplaySpeed: 4500,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          autoplay: !reduceMotion,
          autoplaySpeed: 4500,
        },
      },
    ],
  };

  var recommendationsSlickDefaults = {
    infinite: false,
    autoplay: false,
    speed: 400,
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    draggable: true,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
    waitForAnimate: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function slickOptsForRoot($root) {
    var base = $.extend({}, slickCarouselDefaults);
    var $prev = $root.find('.prev_arr').first();
    var $next = $root.find('.next_Arr_').first();
    if ($prev.length && $next.length) {
      base.prevArrow = $prev;
      base.nextArrow = $next;
    } else {
      base.arrows = false;
    }
    return base;
  }

  function destroyFlickityIfPresent($slider) {
    if (!$slider || !$slider.length || !$slider.data('flickity')) {
      return;
    }
    $slider.flickity('destroy');
  }

  function initRecentlyViewedSliders($) {
    $('.card-slider .product-list').each(function () {
      var $slider = $(this);
      if (!$slider.find('.js-recently-viewed-product').length) {
        return;
      }
      var $root = $slider.closest('.card-slider');
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      $slider.slick(slickOptsForRoot($root));
    });
  }

  function recommendationsSlickOptions($slider, $root) {
    var slideCount = $slider.children('.gallery-cell').length;
    var opts = $.extend({}, recommendationsSlickDefaults, {
      prevArrow: $root.find('.prev_arr').first(),
      nextArrow: $root.find('.next_Arr_').first(),
    });

    if (slideCount > opts.slidesToShow) {
      opts.infinite = true;
    }

    return opts;
  }

  function initRecommendationsSliders($, force) {
    $(
      '.product-recommendations-container .js-recommended-products-slick-slider .products-slider'
    ).each(function () {
      var $slider = $(this);

      if (!$slider.find('.need_to_Add').length) {
        return;
      }

      if ($slider.data('psmRecSlickReady') && !force) {
        return;
      }

      destroyFlickityIfPresent($slider);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      var $root = $slider.closest('.js-recommended-products-slick-slider');
      $slider.slick(recommendationsSlickOptions($slider, $root));
      $slider.data('psmRecSlickReady', true);
    });
  }

  function resetRecommendationsSliders($) {
    $(
      '.product-recommendations-container .js-recommended-products-slick-slider .products-slider'
    ).each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      $slider.removeData('psmRecSlickReady');
    });
  }

  function watchRecommendations($) {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (node) {
      if (node.dataset.psmRecObserved === 'true') {
        return;
      }
      node.dataset.psmRecObserved = 'true';

      var timer;
      var observer = new MutationObserver(function () {
        var $slider = $(node).find(
          '.js-recommended-products-slick-slider .products-slider'
        );

        if (!$slider.length || $slider.data('psmRecSlickReady')) {
          return;
        }

        if (!$slider.find('.need_to_Add').length) {
          return;
        }

        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          initRecommendationsSliders($);
          if ($slider.data('psmRecSlickReady')) {
            observer.disconnect();
          }
        }, 150);
      });

      observer.observe(node, { childList: true, subtree: true });
    });
  }

  function boot($) {
    initRecentlyViewedSliders($);
    initRecommendationsSliders($);
    watchRecommendations($);
  }

  function whenSlickReady(callback, attempt) {
    var tries = attempt || 0;

    if (window.jQuery && jQuery.fn && typeof jQuery.fn.slick === 'function') {
      callback(jQuery);
      return;
    }

    if (tries < 40) {
      window.setTimeout(function () {
        whenSlickReady(callback, tries + 1);
      }, 100);
    }
  }

  function start() {
    whenSlickReady(function ($) {
      boot($);

      window.psmReinitRecentlyViewedSlider = function () {
        initRecentlyViewedSliders($);
      };

      window.psmReinitRecommendationsSlider = function () {
        resetRecommendationsSliders($);
        initRecommendationsSliders($, true);
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
